import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Dialog as MUIDialog,
  DialogContent,
  IconButton,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";

import { useAlert, useAxios } from "../../../hooks";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";
import AudienceSizeForm from "../superadmin campaign details component/AudienceSizeForm";

export default function ShowAudienceSizeDialog({
  formikProps,
  showAudSize,
  audienceSize,
  setShowAudSize,
  isDisabled,
  channelSectionRef,
  scrollToChannelSection,
  setForceClick,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const { campaignID } = useParams();

  const [audienceSizing] = useState({
    values: {
      audience_params: audienceSize?.audience_params,
      audience_size: audienceSize?.audience_size,
      audience_pricing: audienceSize?.audience_pricing,
      distinctCategories: audienceSize?.distinctCategories,
    },
  });

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShowAudSize(false);
  };

  const handleCampaignLive = () => {
    setLoading(true);
    axios({
      url: "/campaign/makeCampaignLive",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: parseInt(campaignID),
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          IsManualCampaignLive: response.data.isManualCampaignLive,
          status: response.data?.status,
          campaignStatus: response.data?.campaignStatus,
          newCampaignStatus: response.data?.campaign_status || "LIVE_REQUESTED",
        }));
        dispatch(
          alert({ type: "success", message: response.message.displayMessage })
        );
        setShowAudSize(false);
      }
      setLoading(false);
    });
  };

  return (
    <MUIDialog open={showAudSize} onClose={handleClose}>
      <Grid container spacing={4} padding={"8px 24px"}>
        <Grid size={6} alignSelf={"center"}>
          <ActiveTextEighteen color={colors.purple}>
            Audience Size
          </ActiveTextEighteen>
        </Grid>

        <Grid size={6} alignSelf={"center"} textAlign={"end"}>
          <IconButton>
            <HighlightOff onClick={() => handleClose()} />
          </IconButton>
        </Grid>
      </Grid>

      <Divider />

      <DialogContent style={{ padding: "24px" }}>
        <Grid container spacing={4}>
          <AudienceSizeForm
            campaign={formikProps?.values}
            formikProps={audienceSizing}
            component="consumer"
          />
        </Grid>

        {formikProps?.values.status !== "ACTIVE" &&
          !formikProps?.values?.IsManualCampaignLive &&
          formikProps.values.campaignStatus !== "Expired" && (
            <Grid container justifyContent={"end"} mt={2}>
              <Grid size="auto" alignSelf={"center"}>
                {!isDisabled && (
                  <Typography
                    variant="h6"
                    onClick={() => {
                      handleClose();
                      setForceClick(false);
                      scrollToChannelSection();
                    }}
                    sx={{
                      marginRight: "8px",
                      cursor: "pointer",
                      color: colors.purple,
                    }}
                  >
                    Add Channel details{" "}
                  </Typography>
                )}
              </Grid>

              <Grid size="auto">
                <PrimaryLoadingButton
                  variant="contained"
                  loading={loading}
                  disabled={!isDisabled}
                  onClick={handleCampaignLive}
                >
                  Campaign Go Live
                </PrimaryLoadingButton>
              </Grid>
            </Grid>
          )}
      </DialogContent>
    </MUIDialog>
  );
}
